module.exports = __webpack_public_path__ + "static/media/replace_notification_configuration_template.b32d97e3.xlsx";